import React, { FC } from 'react';
import { Cancel } from '@mui/icons-material';
import { Dialog, DialogProps, IconButton } from '@mui/material';
import * as Styles from './Modal.styles';

interface ModalProps extends DialogProps {
  open: boolean;
  close: () => void;
  width?: string;
}

const Modal: FC<ModalProps> = ({ open, close, width, children, ...dialogProps }) => {
  return (
    <Dialog open={open} onClose={close} maxWidth="lg" {...dialogProps}>
      <Styles.Container containerWidth={width}>
        <IconButton sx={{ position: 'absolute !important', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        {children}
      </Styles.Container>
    </Dialog>
  );
};

export default Modal;
